import { render, staticRenderFns } from "./Brewers.vue?vue&type=template&id=039ded30&"
import script from "./Brewers.vue?vue&type=script&lang=js&"
export * from "./Brewers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports